module.exports = __webpack_public_path__ + "static/img/11.3001dc3e.png";